module.exports = __webpack_public_path__ + "img/018-019.bc65476d.jpg";